const initialState = {
  existenciaDiaria: null,
  fechaConsultaStock: null,
  dataCamionesCalados: null,
  dataCamionesDescargados: null,
  detalleLiqMercaderia: [],
  acta: null,
  fechaDesde: null,
  fechaHasta: null,
  detalle: null,
  fileOk: false,
  fileDetallePdfOk: false,
  ocultarRechazados: false,
  agruparEntregadores: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'ACTUALIZAR_CAMIONES_CALADOS':
      return {
        ...state,
        fechaDesde: action.fechaD,
        fechaHasta: action.fechaH
      }
    case 'ACTUALIZAR_CAMIONES_DESCARGADOS':
      return {
        ...state,
        fechaDesde: action.fechaD,
        fechaHasta: action.fechaH
      }
    case 'CAMIONES_CALADOS_TODOS':
      return {
        ...state,
        dataCamionesCalados: action.data
      }
    case 'CAMIONES_CALADOS':
      return {
        ...state,
        dataCamionesCalados: action.data
      }
    case 'CAMIONES_DESCARGADOS':
      return {
        ...state,
        dataCamionesDescargados: action.data
      }
    case 'ACTUALIZAR_DETALLES':
      return {
        ...state,
        detalle: action.detalle
      }
    case 'GENERAR_PDF':
      return {
        ...state,
        fileOk: action.fileOk
      }
    case 'GENERAR_DETALLE_PDF':
      return {
        ...state,
        fileDetallePdfOk: action.fileDetallePdfOk
      }
    case 'DETALLE_MERCADERIA':
      return {
        ...state,
        detalleLiqMercaderia: action.data
      }
    case 'INTERDICTO_CARTA_DE_PORTE':
      return {
        ...state,
        acta: action.data
      }
    case 'RELEASE_INTERDICTO_CARTA_DE_PORTE':
      return {
        ...state,
        acta: null
      }
    case 'UPDATE_RECHAZADOS':
      return {
        ...state,
        ocultarRechazados: action.newState
      }
    case 'UPDATE_AGRUPADOS':
      return {
        ...state,
        agruparEntregadores: action.newState
      }
    default:
      return state
  }
}
